import React from "react";
import { withStyles } from "@material-ui/core";
import Button from "@mui/material/Button";

export default function SubmitButtons(props) {
  const ColorButton = withStyles((theme) => ({
    root: {
      borderRadius: "40px !important",
      width: "150px",
      height: "42px",
    },
  }))(Button);

  return <ColorButton variant="contained" {...props} />;
}
